export default "__VITE_ASSET__Ct$uYvsW__"